import React, { Component } from 'react';
import { connect } from 'react-redux';
import './TimeTable.css';
import SimpleTable from 'components/shared/table/SimpleTable';
import { getCurrentUser } from 'selectors/authentication';
import { usersUtil, ROLES, TYPES } from 'services/utils/users-util';
import Number from 'components/shared/text/Number';
import {
  rateSelector,
  timeIdRateToEditSelector,
  timeSelector,
} from 'components/admin/work-orders/details/time/store/selectors';
import Button from 'components/shared/button/Button';
import {
  confirmRate,
  deleteTime,
  setCurrentTimeRateToEdit,
  setCurrentTimeToEdit,
  setRate,
  setShowAddTimeModal,
} from 'components/admin/work-orders/details/time/store/actions';
import Input from 'components/shared/input/Input';
import AddTimeModal from 'components/admin/work-orders/details/time/AddTimeModal';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import Date from 'components/shared/text/Date';
import Time from 'components/shared/text/Time';

class TimeTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteConfirmation: false,
      timeToDelete: null,
    };
  }

  handleDeleteConfirmation = (result) => {
    if (result) {
      this.props.dispatch(deleteTime(this.state.timeToDelete));
    }
    this.setState({
      showDeleteConfirmation: false,
      timeToDelete: null,
    });
  };

  mapTime = (timeEntries, ratesAvailable) => {
    const { dispatch, rate, timeIdRateToEdit } = this.props;
    return timeEntries.map((time) => {
      let row = [
        time.task_number,
        time.name_title,
        time.start_date ? <Date value={time.start_date} format="ll" /> : 'N/A',
        time.time_in ? <Time value={time.time_in} /> : 'N/A',
        time.time_out ? <Time value={time.time_out} /> : 'N/A',
        <span>
          <Number value={time.hours_worked || 0} format="0.[00]" /> hours
        </span>,
      ];
      if (ratesAvailable) {
        if (timeIdRateToEdit !== null && timeIdRateToEdit === time.id) {
          row.push(
            <Input
              className="rate-input"
              type="number"
              value={rate}
              onChange={(value) => dispatch(setRate(value))}
            />
          );
          row.push(
            <div>
              <Button
                className="button-orange time-button"
                label="Confirm"
                onClick={() =>
                  dispatch(confirmRate(time.task_id, time.id, rate))
                }
              />
              <Button
                className="button-white time-button"
                label="Cancel"
                onClick={() => dispatch(setCurrentTimeRateToEdit(null))}
              />
            </div>
          );
        } else {
          row.push(
            time.rate !== null ? (
              <Number format="$0" value={time.rate} />
            ) : (
              'N/A'
            )
          );
          row.push(
            <Button
              className="button-orange time-button"
              label="Edit rate"
              onClick={() =>
                this.props.dispatch(
                  setCurrentTimeRateToEdit(time.id, time.rate)
                )
              }
            />
          );
        }
        row.push(
          <Number
            value={time.cost !== null ? time.cost : 0}
            format="$0,0.[00]"
          />
        );
        row.push(
          <div
            className="edit-delete-buttons-container"
            style={{ display: 'flex' }}
          >
            <Button
              className="button-blue-grey"
              label="Edit"
              onClick={() => {
                this.props.dispatch(setCurrentTimeToEdit(time));
                this.props.dispatch(setShowAddTimeModal(true));
              }}
            />
            <Button
              className="button-blue-grey"
              label="Delete"
              onClick={() =>
                this.setState({
                  showDeleteConfirmation: true,
                  timeToDelete: time.id,
                })
              }
            />
          </div>
        );
      } else {
        row.push(
          <div
            className="edit-delete-buttons-container"
            style={{ display: 'flex' }}
          >
            <Button
              className="button-blue-grey"
              label="Delete"
              onClick={() =>
                this.setState({
                  showDeleteConfirmation: true,
                  timeToDelete: time.id,
                })
              }
            />
          </div>
        );
      }
      return row;
    });
  };

  render() {
    const { currentUser } = this.props;
    const ratesAvailable =
      usersUtil.hasRole(currentUser, ROLES.OWNER) ||
      usersUtil.hasRole(currentUser, ROLES.CONTRACTOR_PROJECT_MANAGER) ||
      usersUtil.hasType(currentUser, TYPES.GENERAL_CONTRACTOR);
    let headers = [
      'TASK #',
      'NAME/TITLE',
      'START DATE',
      'TIME IN',
      'TIME OUT',
      'HOURS',
    ];
    if (ratesAvailable) {
      headers = headers.concat(['RATE', '', 'TOTAL']);
    }
    // Buttons column
    headers.push('');

    return (
      <div className="time">
        <SimpleTable
          className={`time-table${ratesAvailable ? ' editable' : ''}`}
          headers={headers}
          rows={this.mapTime(this.props.time, ratesAvailable)}
          emptyMessage="No Time Entries"
        />
        {ratesAvailable && (
          <Button
            className="button-orange add-time-button"
            label="Add Time"
            onClick={() => {
              this.props.dispatch(setCurrentTimeToEdit(null));
              this.props.dispatch(setShowAddTimeModal(true));
            }}
          />
        )}
        <AddTimeModal />
        <ConfirmationModal
          show={this.state.showDeleteConfirmation}
          message={'Are you sure you want to delete this item?'}
          onHide={this.handleDeleteConfirmation}
        />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    rate: rateSelector(state),
    time: timeSelector(state),
    timeIdRateToEdit: timeIdRateToEditSelector(state),
  };
})(TimeTable);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/time/TimeTable.js